import React from 'react'
import { DesignSystem } from '@/src/design-system'
import { Error } from './error'
import * as CardAccounts from '@/src/experiences/card-accounts'

export function Gate<
  TProps extends {
    cardAccountId?: (typeof CardAccounts.Stores.CardAccountsApi.endpoints)['GET /card/accounts']['Types']['ResultType'][number]['id']
  },
>({
  Platform,
  Highnote,
}: {
  Platform: React.ComponentType<TProps>
  Highnote: React.ComponentType<TProps>
}) {
  const Component = (props: TProps) => {
    const getFirstAccount = CardAccounts.Hooks.useGetFirstAccount()

    if (getFirstAccount.isLoading || getFirstAccount.isUninitialized) {
      return <DesignSystem.Loading.Screen />
    } else if (getFirstAccount.data) {
      return getFirstAccount.data.id ? (
        <Platform cardAccountId={getFirstAccount.data.id} {...props} />
      ) : (
        <Highnote {...props} />
      )
    } else if (getFirstAccount.error) {
      return <Error />
    } else {
      return null
    }
  }

  return Component
}
